var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 10.6667L4.66667 8.00001M4.66667 8.00001L7.33333 5.33334M4.66667 8.00001H14M10.6667 10.6667V11.3333C10.6667 11.8638 10.456 12.3725 10.0809 12.7476C9.70581 13.1226 9.1971 13.3333 8.66667 13.3333H4C3.46957 13.3333 2.96086 13.1226 2.58579 12.7476C2.21071 12.3725 2 11.8638 2 11.3333V4.66667C2 4.13624 2.21071 3.62753 2.58579 3.25246C2.96086 2.87739 3.46957 2.66667 4 2.66667H8.66667C9.1971 2.66667 9.70581 2.87739 10.0809 3.25246C10.456 3.62753 10.6667 4.13624 10.6667 4.66667V5.33334",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOutline);
export default __webpack_public_path__ + "static/media/LogoutOutline.afdd696dc713a8b1014750b2e04b87e8.svg";
export { ForwardRef as ReactComponent };